import { STATUS_ENUM } from '@innovyze/stylovyze';
import { AnyAction, createReducer } from '@reduxjs/toolkit';

import { IntegrationsStoreState } from '../../types/integration.types';
import {
	deleteIntegration,
	deleteIntegrationResolved,
	getIntegrations,
	getIntegrationsRejected,
	getIntegrationsResolved,
	getSingleIntegrationById,
	getSingleIntegrationByIdResolved,
	updateIntegration,
	updateIntegrationResolved,
} from '../actions/integrations.actions';

export const initialState: IntegrationsStoreState = {
	initialized: false,
	integrationById: { status: STATUS_ENUM.IDLE },
};

interface IntegrationsActions {
	[x: string]: (
		state: IntegrationsStoreState,
		action: AnyAction,
	) => IntegrationsStoreState | undefined;
}

const reducer: IntegrationsActions = {
	[getIntegrations.toString()]: () => initialState,
	[getIntegrationsResolved.toString()]: (state, action) => ({
		...state,
		paginatedIntegrations: {
			integrations: action.payload,
			// pagination: action.payload.pagination,
			status: STATUS_ENUM.SUCCESS,
		},
		[getIntegrationsRejected.toString()]: (
			state: IntegrationsStoreState,
		) => ({
			...state,
			paginatedIntegrations: {
				initialized: true,
				status: STATUS_ENUM.ERROR,
			},
		}),
	}),
	[deleteIntegration.toString()]: state => ({
		...state,
	}),
	[deleteIntegrationResolved.toString()]: state => ({
		...state,
	}),
	[updateIntegration.toString()]: state => ({
		...state,
	}),
	[updateIntegrationResolved.toString()]: state => ({
		...state,
	}),
	[getSingleIntegrationById.toString()]: state => ({
		...state,
		integrationById: { status: STATUS_ENUM.PENDING },
	}),
	[getSingleIntegrationByIdResolved.toString()]: (state, action) => ({
		...state,
		integrationById: {
			status: STATUS_ENUM.SUCCESS,
			integration: action.payload,
		},
	}),
};

export default createReducer(initialState, reducer);
